import React from "react";
import Loading from "./loading";
import callApiPromise from "../helpers/call-api-promise";
import { connect } from "react-redux";

function loadScript(src) {
    return new Promise(function(resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function() {
            resolve();
        });
        script.addEventListener("error", function(e) {
            reject(e);
        });
        document.body.appendChild(script);
    });
}

global.recaptchaV2SetLoaded = () => {
    global.RecaptchaV2Loaded = true;
};

class RecaptchaV2Unwrapped extends React.PureComponent {
    constructor(props) {
        super(props);
        this.captchaContainer = React.createRef();
    }
    state = {
        success: false,
        loading: true,
        score: null
    };
    onSuccessCaptcha = token => {
        console.log("onssucccess", token);

        if (this.props.handleToken) {
            this.props.handleToken(token);
            return;
        }
    };
    onErrorCaptcha = e => {
        console.log("onerror", e);
        this.setState({
            error: true
        });
    };
    onExpireCaptcha = e => {
        console.log("onexpire", e);
        this.setState({
            loading: true,
            error: false,
            success: false
        });
    };

    componentDidMount() {
        let scriptLoaded = !!global.grecaptcha
            ? Promise.resolve()
            : loadScript(
                  `https://www.google.com/recaptcha/api.js?render=explicit`
              );

        scriptLoaded
            .then(() => {
                if (global.grecaptcha) {
                    global.grecaptcha.ready(() => {
                        // eslint-disable-next-line no-undef
                        grecaptcha.render(this.captchaContainer.current, {
                            sitekey: this.props.recaptchaV2Key,
                            callback: this.onSuccessCaptcha,
                            "error-callback": this.onErrorCaptcha,
                            "expired-callback": this.onExpireCaptcha
                        });
                    });
                } else {
                    this.setState({
                        error: true
                    });
                }
            })
            .catch(e => {
                console.error(e);
                this.setState({
                    error: true
                });
            });
    }
    render() {
        let content;
        if (this.state.success) {
            content = this.props.children;
        } else if (this.state.error) {
            content = (
                <div className="current-plan warning">
                    Something went wrong, please disable any active browser
                    extensions, reload the page and try again. If you continue
                    to have problems, let us know at{" "}
                    <a href="mailto:info@thenounproject.com" target="_blank">
                        info@thenounproject.com
                    </a>
                </div>
            );
        } else if (this.state.loading) {
            content = null;
        } else {
            content = <div className="current-plan warning">You are robot</div>;
        }
        return (
            <React.Fragment>
                {content}
                <div
                    data-testid="captcha-container"
                    ref={this.captchaContainer}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const { auth } = state;
    let { recaptchaV2Key } = auth;
    return {
        recaptchaV2Key
    };
};

export const RecaptchaV2 = connect(mapStateToProps)(RecaptchaV2Unwrapped);
